import LocalPizzaIcon from '@mui/icons-material/LocalPizza';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import PublishedWithChangesSharpIcon from '@mui/icons-material/PublishedWithChangesSharp';
import CheckCircleOutlineSharpIcon from '@mui/icons-material/CheckCircleOutlineSharp';
import HighlightOffSharpIcon from '@mui/icons-material/HighlightOffSharp';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CoffeeIcon from '@mui/icons-material/Coffee';
import LocalBarIcon from '@mui/icons-material/LocalBar'; // Per Cocktail e Spritz
import WineBarIcon from '@mui/icons-material/WineBar'; // Per i Vini
import SportsBarIcon from '@mui/icons-material/SportsBar'; // Per le Birre
import LocalDrinkIcon from '@mui/icons-material/LocalDrink'; // Per Bibite e Analcolici
import DinnerDiningIcon from '@mui/icons-material/DinnerDining'; // Per Taglieri e Insalate
import LiquorIcon from '@mui/icons-material/Liquor'; // Icona per la Bottiglia
import { IconButton, Tooltip, Stack, Typography } from '@mui/material';


export default function RendersIcons({ title, valueToCopy }) {
    const handleCopy = () => {
        navigator.clipboard.writeText(valueToCopy)
            .then(() => {
                console.log("Copy:", valueToCopy);
            })
            .catch(err => {
                console.error("Errore Copy", err);
            });
    };
    switch (title) {
        case "PIZZA": return (<LocalPizzaIcon />)
        case "PENDING": return (<PendingActionsIcon />)
        case "IN_PROGRESS": return (<PublishedWithChangesSharpIcon />)
        case "COMPLETED": return (<CheckCircleOutlineSharpIcon />)
        case "CANCELLED": return (<HighlightOffSharpIcon />)
        case "COPY":
            return (
                <Stack direction="row" spacing={1} alignItems="center">
                    <Tooltip title="Copy Order n.">
                        <IconButton onClick={handleCopy} size="small">
                            <ContentCopyIcon />
                        </IconButton>
                    </Tooltip>
                    <Typography variant="body2">
                        {valueToCopy}
                    </Typography>
                </Stack>
            );
        case 'CAFFETTERIA':
            return <CoffeeIcon sx={{ color: '#C5A039' }} />;
        case 'PIZZE':
            return <LocalPizzaIcon sx={{ color: '#C5A039' }} />;
        case 'BIRRE':
        case 'BIRRE ALLA SPINA':
            return <SportsBarIcon sx={{ color: '#C5A039' }} />;
        case 'VINI BIANCHI':
        case 'VINI ROSSI':
            return <WineBarIcon sx={{ color: '#C5A039' }} />;
        case 'COCKTAIL':
        case 'SPRITZ':
        case 'GIN TONIC/LEMON':
            return <LocalBarIcon sx={{ color: '#C5A039' }} />;
        case 'BIBITE':
        case 'ANALCOLICI':
            return <LocalDrinkIcon sx={{ color: '#C5A039' }} />;
        case 'TAGLIERI':
        case 'INSALATE':
            return <DinnerDiningIcon sx={{ color: '#C5A039' }} />;
        case 'AMARI':
            return <LiquorIcon sx={{ color: '#C5A039' }} />;
        default:
            return <LocalDrinkIcon sx={{ color: '#C5A039' }} />;
    }
}